<template>

  <div class="app-main footer-style-one" >
    <el-card class="box-card">

      <div style="margin-bottom: 20px">
        <el-button type="default" size="small" @click="goBack()">返回 </el-button>
        <el-button type="primary" size="small" @click="viewAnswer()">查看答案 </el-button>
      </div>

    <el-form ref="form" :model="row" label-width="80px">
      <el-form-item label="课程">
        <el-input v-model="row.majorName" disabled></el-input>
      </el-form-item>
      <el-form-item label="得分">
        <el-input v-model="row.score" disabled></el-input>
      </el-form-item>

      <el-form-item label="用时">
        <el-input v-model="row.use_time" disabled></el-input>
      </el-form-item>

      <el-form-item label="总分数">
        <el-input v-model="row.total_score" disabled></el-input>
      </el-form-item>

      <el-form-item label="正确题数">
        <el-input v-model="row.correct" disabled></el-input>
      </el-form-item>

      <el-form-item label="错误题数">
        <el-input v-model="row.error" disabled></el-input>
      </el-form-item>

      <el-form-item label="未做题数">
        <el-input v-model="row.undo" disabled></el-input>
      </el-form-item>

      <el-form-item label="开始时间">
        <el-input v-model="row.created_at" disabled></el-input>
      </el-form-item>
    </el-form>
    </el-card>
  </div>

</template>

<script>



export default {
  data() {
    return {
      row:{}
    }
  },

  components: {

  },

  created() {

    document.title  = '考试详情'
    this.row = JSON.parse(decodeURIComponent(this.$route.query.row))
    console.log(this.row)

  },


  methods: {

    viewAnswer(){
      this.$router.push({
        path: '/testResult',
        query: {
          major_id: this.row.major_id,
          majorName: this.row.majorName,
          examRecordid: this.row.id,
        }
      })

    },
    goBack(){
      this.$router.go(-1)

    },

  }
}
</script>

<style>
.footer-style-one.app-main {
  min-height: calc(100vh - 150px);
}
.app-main {
  min-height: 100vh;
  /*padding-top: 66px;*/
  /*background-color: #f6f8fb;*/
}
.app_container {
  padding-bottom: 25px;
}
.w {
  width: 1200px;
  margin: auto;
}

.block{
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.carousel {
  width: 820px;
}
.el-carousel--horizontal {
  overflow-x: hidden;
}
.el-carousel {
  --el-carousel-arrow-font-size: 12px;
  --el-carousel-arrow-size: 36px;
  --el-carousel-arrow-background: rgba(31, 45, 61, .11);
  --el-carousel-arrow-hover-background: rgba(31, 45, 61, .23);
  --el-carousel-indicator-width: 30px;
  --el-carousel-indicator-height: 2px;
  --el-carousel-indicator-padding-horizontal: 4px;
  --el-carousel-indicator-padding-vertical: 12px;
  --el-carousel-indicator-out-color: var(--el-border-color-hover);
  position: relative;
}
.el-carousel__container {
  position: relative;
  height: 300px;
}

.el-carousel__item.is-animating {
  transition: transform .4s ease-in-out;
}
.el-carousel__item.is-active {
  z-index: calc(var(--el-index-normal) - 1);
}
.el-carousel__item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: inline-block;
  overflow: hidden;
  z-index: calc(var(--el-index-normal) - 1);
}
a {
  color: inherit;
  text-decoration: inherit;
}
a {
  font-weight: 400;
  color: var(--el-color-black);
}
a {
  color: inherit;
  text-decoration: inherit;
}
.carousel .article_img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

img, video {
  max-width: 100%;
  height: auto;
}
img, canvas, iframe, video {
  display: block;
  vertical-align: middle;
}

.carousel .el-carousel__indicators {
  background: rgba(0,0,0,.2);
  border-radius: 15px;
  bottom: 20px;
  padding: 0 6px 4px 12px;
}
.el-carousel__indicators--horizontal {
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
}
.el-carousel__indicators {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  z-index: calc(var(--el-index-normal) + 1);
}

.carousel .el-carousel__indicator--horizontal {
  padding: 0;
}
.el-carousel__indicator--horizontal {
  display: inline-block;
  padding: var(--el-carousel-indicator-padding-vertical) var(--el-carousel-indicator-padding-horizontal);
}
.el-carousel__indicator {
  background-color: transparent;
  cursor: pointer;
}

.carousel .is-active .el-carousel__button {
  width: 15px;
}
.el-carousel__indicator.is-active button {
  opacity: 1;
}
.carousel .el-carousel__button {
  width: 9px;
  height: 6px;
  border-radius: 15px;
  margin-right: 7px;
}
.el-carousel__button {
  display: block;
  opacity: .48;
  width: var(--el-carousel-indicator-width);
  height: var(--el-carousel-indicator-height);
  background-color: #fff;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: var(--el-transition-duration);
}
input, button {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  padding: 0;
  line-height: inherit;
  color: inherit;
}

.hot {
  width: 360px;
  background: #FFFFFF;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 12px 15px 0;
}
.hot .recommend {
  font-size: 20px;
  margin-bottom: 15px;
}
p, h5 {
  margin: 0;
}
.hot .no_data{
  color: #999;
  text-align: center;
  line-height: 353px;
}
.category_list {
  margin-top: 20px;
  background: #fff;
  padding: 10px 10px 0;
  border-radius: 5px;
}
.styleChange .active {
  background: #fff;
  position: relative;
}
.styleChange .items {
  padding-bottom: 10px;
}
.category_list .active {
  color: #2256f6;
  background: rgba(34,86,246,.05);
}
.category_list .items{
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 10px;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}

.styleChange .items{
  padding-bottom: 10px;
}
.category_list .items {
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 10px;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}


.article_list {
  display: flex;
  flex-wrap: wrap;
  row-gap: 20px;
  margin-top: 20px;
}
.article_item:nth-child(odd) {
  margin-right: 20px;
}
.article_item {
  position: relative;
  padding: 14px;
  width: 590px;
  height: 120px;
  box-sizing: border-box;
  background: #FFFFFF;
  border-radius: 5px;
  cursor: pointer;
}
.article_item .wrap{
  display: flex;
  -moz-column-gap: 12px;
  column-gap: 12px;
}
.article_item .texts {
  flex: 1;
}
.article_item .title {
  margin-bottom: 5px;
  font-size: 16px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  word-break: break-all;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
p, h5 {
  margin: 0;
}
.article_item .summary {
  color: #999;
  font-size: 12px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.article_item .img_box {
  width: 162px;
  height: 90px;
  overflow: hidden;
  border-radius: 5px;
}

.article_item .img_box img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
img, video {
  max-width: 100%;
  height: auto;
}
img, canvas, iframe, video {
  display: block;
  vertical-align: middle;
}

.article_item .counts {
  position: absolute;
  bottom: 14px;
}
.article_item .count {
  font-size: 12px;
  color: #999;
}

article_item .border{
  display: inline-block;
  margin: 0 10px;
  width: 1px;
  height: 10px;
  background: #BECADB;
}
.border, .\.border {
  border-width: 1px;
}





</style>
